<template>
  <div class="text-center">
    <a href="#"
       class="text-gray-700 underline hover:text-green-600 cursor-pointer"
       @click.prevent="openModal"
    >
      View Object Data
    </a>

    <div v-if="isModalOpen" >
      <Teleport to="body">
        <JSON_Modal
          :json-data="params.data[params.colDef.field]"
          :title="getModalTitle()"
          @close="isModalOpen = false"
        />
      </Teleport>
    </div>

  </div>
</template>

<script>
import JSON_Modal from '@/components/widgetcomponents/JSON_Modal.vue';

export default {
  name: 'CCObjectJSONModal',
  components: {
    JSON_Modal
  },
  data() {
    return {
      isModalOpen: false,
    };
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    getModalTitle() {
      if (this.params && this.params.colDef) {
        return this.params.colDef.headerName || this.params.colDef.field || 'Object Data';
      }
      return 'Object Data';
    },
  },
};
</script>
